import { useGetUserCardBalance } from "../../../../../../core/services/react-query/report/cards";
import { formatNumber } from "../../../../../../core/utils/common";
import Text from "../../../../../../core/utils/Text";
import { Column, Row } from "../../../../../../styles/CommonStyles";
import { BalanceWrapper } from "../../../../../../styles/main/user";
import CoinRow from "../../../../../common/common/CoinRow";

const UserCardBalance = ({ userId }) => {

	const { data, isLoading } = useGetUserCardBalance(userId);

	const balance = data?.balance;

	return (
		<BalanceWrapper fw>

			<Row cs={CS} header>
				{headers.map((head) => (
					<Column key={head}>
						<Text tid={head} />
					</Column>
				))}
			</Row>

			{!isLoading && balance && (
				<Row cs={CS} index={0}>

					<Column>
						1
					</Column>

					<Column>
						<CoinRow
							coin={{
								id: balance.currency?.toLowerCase(),
							}}
						/>
					</Column>

					<Column>
						{formatNumber(balance.available)}
					</Column>

					<Column>
						{data?.status}
					</Column>

				</Row>
			)}

		</BalanceWrapper>
	);
};

const CS = "10% 30% 30% 30%";

const headers = [
	"index",
	"market",
	"available",
	"status",
];

export default UserCardBalance;